import API from '..';

const preAuth = (data) => API.post('/api/v1/pre-auth/', data);

export default preAuth;
